import { Component, EventEmitter, Input, OnInit, Output, DestroyRef, inject } from '@angular/core';
import { CartItem } from "../../../services/cart/cart-item";
import { CartService } from "../../../services/cart/cart.service";
import { ShoppingCart } from "../../../services/cart/shopping-cart";
import { OrganizationLogicService } from "../../../services/organization-logic/organization-logic.service";
import { RnOrganizationPaymentOnFileVM } from "../../../services/rnapi2-service/models/models";
import { ValidatePromoCodeVM } from "../change-package-inventory/validate-promo-code-vm";
import { CollectionView } from "@mescius/wijmo";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
    selector: "app-shopping-cart",
    templateUrl: "./shopping-cart.component.html",
    styleUrls: ["./shopping-cart.component.scss"],
    standalone: false
})
export class ShoppingCartComponent implements OnInit {
  private readonly cartService = inject(CartService);
  private readonly orgLogicService = inject(OrganizationLogicService);
  private readonly destroyRef = inject(DestroyRef);

  @Input() PaymentInfo: RnOrganizationPaymentOnFileVM;
  @Input() IsInline = false;
  @Output() CloseCart: EventEmitter<void> = new EventEmitter<void>();

  nextBillAmount: any;
  nextBillTotal: number;
  promoCodeIsValid = false;
  validatedPromo: ValidatePromoCodeVM = new ValidatePromoCodeVM();
  cartCollectionView!: CollectionView<CartItem>;

  shoppingCart: ShoppingCart;
  canShowPromoCodeEntry: boolean;

  showGridArea: boolean;
  showPaymentArea: boolean;
  showACHInfo: boolean;
  showCCInfo: boolean;
  showTotalDue: boolean;
  showFutureMonthlyBill: boolean;

  ngOnInit(): void {
    this.nextBillAmount = this.PaymentInfo?.NextBillAmount;
    this.cartService.getCart()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((r) => {
        this.shoppingCart = r;
        this.cartCollectionView = new CollectionView(this.shoppingCart.items);
      })
    this.canShowPromoCodeEntry = this.orgLogicService.CanShowPromoCodeEntry();
    this.validatedPromo = this.cartService.getPromo();

    this.showPaymentArea = this.PaymentInfo && !this.IsInline;
    this.showACHInfo =
      this.PaymentInfo?.PaymentMethods[0]?.PaymentMethodType === "ACH";
    this.showCCInfo =
      this.PaymentInfo?.PaymentMethods[0]?.PaymentMethodType !== "ACH";
    this.updateVisualProperties();
  }

  hideShoppingCart(): void {
    this.CloseCart.emit();
  }

  updateVisualProperties() {
    this.showGridArea =
      !this.IsInline || (this.IsInline && this.cartCollectionView?.items.length > 0);
    this.showTotalDue = this.shoppingCart.items.length > 0;
    this.showFutureMonthlyBill = this.shoppingCart.items.length > 0;
  }

  applyPromo(promo: any) {
    this.promoCodeIsValid = !!promo;
    this.validatedPromo = promo;
    this.cartService.updateTotal(this.validatedPromo);
    if (this.promoCodeIsValid) {
      this.nextBillTotal = this.cartService.updateTotal(this.validatedPromo);
    }
  }
}
